import styles from './styleBtn.module.scss'
import Stack from '@mui/material/Stack';
import Button from '@mui/material/Button';
import { useEffect, useState } from 'react';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import ArrowDropUpIcon from '@mui/icons-material/ArrowDropUp';



function BtnSaveMenu({ text, children, ...props }) {
    return (
        <Stack spacing={2} direction="row">
            <Button {...props} variant="text">{text}</Button>
        </Stack>
    )
}

function BtnModalOrder({ text, handleAdd, handleMinus, changeValue, item, list, ...props }) {
    const [num, setNum] = useState(text)
    const [numPreview, setNumPreview] = useState(text)
    useEffect(() => {
        setNum(text)
        setNumPreview(text)
    }, [item])
    return (
        <div className={styles.btnOrder} {...props}>
            <button onClick={() => {handleMinus(item, item.order - 1)}}>
                <ArrowDropUpIcon />
            </button>
            <button onClick={() => handleAdd(item, item.order + 1)}>
                <ArrowDropDownIcon />
            </button>
        </div>
    )
}

export {  BtnModalOrder, BtnSaveMenu }
